import { createContext, useContext } from 'react';

const EventNotificationsEventIdContext = createContext<undefined | number>(undefined);

export function EventNotificationsEventIdProvider(props: {
    children: React.ReactNode;
    eventId: number | undefined;
}) {
    return (
        <EventNotificationsEventIdContext.Provider value={props.eventId}>
            {props.children}
        </EventNotificationsEventIdContext.Provider>
    );
}

export function useEventNotificationsEventId(): number | undefined {
    return useContext(EventNotificationsEventIdContext);
}
